Ext.define('WindowSterowanieTramwajeManual', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.sterowanie_trybem_manual.capitalise(),
    width: 550,
    closable: false,
    collapsible: false,
    scrollable: false,
    modal: true,
    resizable: false,
    layout: 'fit',
    initComponent: function () {
        this.cid = Ext.id();
        this.items = [{
            xtype: 'panel',
            layout: 'column',
            items: [{
                columnWidth: 1,
                xtype: 'form',
                id: this.cid + 'formpanel',
                bodyStyle: 'padding:10px 10px 10px 10px',
                scrollable: true,
                defaults: {
                    labelWidth: 150,
                    labelAlign: WindowExdMobileDEVICEV ? 'top' : 'left',
                    anchor: "0"
                },
                items: [{
                    xtype: 'radiogroupexd',
                    id: this.cid + "manualmode",
                    name: "manualmode",
                    baseCls: 'x-radio-column',
                    fieldLabel: Lang.wybierz_tryb.capitalise(),
                    columns: 1,
                    vertical: false,
                    items: [{
                        boxLabel: Lang.wlaczony.capitalise(),
                        inputValue: true
                    }, {
                        boxLabel: Lang.wylaczony.capitalise(),
                        inputValue: false,
                        value: true
                    }]
                }]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'zapisz',
            text: Lang.zapisz,
            scope: this,
            handler: this.saveOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showW: function (obiektid) {
        if (!validPrivilegesOperatorComplex(ViewTramwaje.accessPropertyName)) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        sendAjaxDataJsonRpcL("rest/tramwaje/getManualModeStatus", {}, this, function (data) {
            if (data.status) {
                Ext.getCmp(this.cid + "manualmode").setValue(data.data);
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
        this.show();
        this.center();
    },
    saveOp: function () {
        if (!validPrivilegesOperatorComplex(ViewTramwaje.accessPropertyName)) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        let enableManualMode = Ext.getCmp(this.cid + "manualmode").getValue();
        sendAjaxDataJsonRpcL("rest/tramwaje/saveManualModeStatus?enable=" + enableManualMode, {}, this, function (data) {
            if (data.status) {
                this.closeOp();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    closeOp: function () {
        this.close();
    }
});
